var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldSunFog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.98 11.73A6.998 6.998 0 0 0 12 5.25c-3.69 0-6.71 2.85-6.98 6.48a.5.5 0 0 0 .5.52h12.96a.5.5 0 0 0 .5-.52z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.92 13c-.55 0-1-.45-1-1s.45-1 1-1 1.04.45 1.04 1-.41 1-.96 1h-.08zM2 13c-.55 0-1-.45-1-1s.45-1 1-1 1.04.45 1.04 1-.41 1-.96 1H2zm16.3-7.3a.996.996 0 0 1 0-1.41l.13-.13a.996.996 0 1 1 1.41 1.41l-.13.13c-.19.19-.44.29-.7.29-.26 0-.51-.1-.71-.29zm-14.02 0-.13-.14a.996.996 0 1 1 1.41-1.41l.13.13c.39.39.39 1.02 0 1.41-.19.2-.45.3-.7.3-.26 0-.51-.1-.71-.29zM11 2.08V2c0-.55.45-1 1-1s1 .45 1 1-.45 1.04-1 1.04-1-.41-1-.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h16c.41 0 .75.34.75.75s-.34.75-.75.75H4zM6 18.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h12c.41 0 .75.34.75.75s-.34.75-.75.75H6zM9 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSunFog);
export default __webpack_public_path__ + "static/media/vuesax-bold-sun-fog.b4607c519fa77acd1fdc87817d26bd12.svg";
export { ForwardRef as ReactComponent };